import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function CheckedIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
    >
      <g clipPath="url(#clip0_551_6344)">
        <path
          d="M4 10.4L0 6.4L1.4 5L4 7.6L10.6 1L12 2.4L4 10.4Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_551_6344">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
